import React from 'react';
import Spinner from 'ui/Spinner';
import styled from 'styled-components';
import SwiperPlaceholder, { NumericalPlaceholder } from './Placeholder';

const LoadingWrapper = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// eslint-disable-next-line react/prop-types
const LoadingIndicator = (Component) => ({ error }) => {
  if (error) {
    return <div>Error!</div>;
  } else {
    return <Component />;
  }
};

export const SwiperLoading = LoadingIndicator(SwiperPlaceholder);
export const NumericalLoading = LoadingIndicator(NumericalPlaceholder);

// eslint-disable-next-line react/prop-types
export default function ({ error, pastDelay }) {
  if (error) {
    //Error: Cannot create styled-component for component: undefined at /app/ui/ScreenSaver/IdleTimeoutDialog/index.js
    return <div>Error!</div>; 
  } else if (pastDelay) {
    return <LoadingWrapper><Spinner/></LoadingWrapper>;
  } else {
    return null;
  }
}
